module.exports = __webpack_public_path__ + "static/media/electronicsAd.90f95ae5.jpg";